import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface LearningObjectiveCheckListProps {
  children: ReactNode;
  className?: string;
}

/**
 * Unordered checklist shell for storyboard learning-objective items.
 */
const LearningObjectiveCheckList = ({
  children,
  className,
}: LearningObjectiveCheckListProps) => (
  <ul className={cn("list-none space-y-3 pl-0", className)}>{children}</ul>
);

export default LearningObjectiveCheckList;
